export default __webpack_public_path__ + "static/media/tooltip_green_outline.36cdbde6.svg";